import { BannerRepository } from '../../domain/repositories/banner.repository';
import { BannerEntity } from '../../domain/entities/banner.entity';

export class SaveBannerUseCase {
  constructor(private readonly bannerRepository: BannerRepository) {}

  async execute(banner: BannerEntity): Promise<BannerEntity> {
    return this.bannerRepository.saveBanner(banner);
  }
}
